window.theme = window.theme || {};
window.slate = window.slate || {};

(function(e,f){var b={},g=function(a){b[a]&&(f.clearInterval(b[a]),b[a]=null)};e.fn.waitUntilExists=function(a,h,j){var c=this.selector,d=e(c),k=d.not(function(){return e(this).data("waitUntilExists.found")});"remove"===a?g(c):(k.each(a).data("waitUntilExists.found",!0),h&&d.length?g(c):j||(b[c]=f.setInterval(function(){d.waitUntilExists(a,h,!0)},500)));return d}})(jQuery,window);

Number.prototype.zeroPad = function() {
   return ('0'+this).slice(-2);
};


String.prototype.slug = function() {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return this.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
  // return this.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-');
};

 String.prototype.handleize = function() {
  var str = this.toLowerCase();

  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  
  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
  }

  if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
  }

  return str
 }


Array.prototype.remove = function() {
  var what, a = arguments, L = a.length, ax;
  while (L && this.length) {
    what = a[--L];
    while ((ax = this.indexOf(what)) !== -1) {
      this.splice(ax, 1);
    }
  }
  return this;
};

String.prototype.trimToLength = function(m) {
  return (this.length > m) 
    ? jQuery.trim(this).substring(0, m).trim(this) + "..."
    : this;
};

function ISOvalid(str) {
  return !/[^\u0000-\u00ff]/g.test(str);
}

function createCookie(name, value, minutes) {
  var expires;

  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}

function yotpoLoad() {
  yotpoLoaded = false
  
  initReviews = function(noscroll = false) {
    if (noscroll) {
      yotpoLoaded = true
      var e=document.createElement("script");e.type="text/javascript",e.async=!0,e.src="//staticw2.yotpo.com/Ldiy16f1voU1FRn6K8HYkkRphXiJoqL5svADAfaF/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t);

    } else {
      scrollTop = $(window).scrollTop()

      if ($('#shopify-section-product-template').length) {
        if (scrollTop + $(window).height() > $('#shopify-section-product-template').offset().top + $('#shopify-section-product-template').outerHeight()/2) {
          if (!yotpoLoaded) {
            yotpoLoaded = true
            var e=document.createElement("script");e.type="text/javascript",e.async=!0,e.src="//staticw2.yotpo.com/Ldiy16f1voU1FRn6K8HYkkRphXiJoqL5svADAfaF/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t);
          }
        }
      } else {
        if (!yotpoLoaded) {
          yotpoLoaded = true
          var e=document.createElement("script");e.type="text/javascript",e.async=!0,e.src="//staticw2.yotpo.com/Ldiy16f1voU1FRn6K8HYkkRphXiJoqL5svADAfaF/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t);
        }
      }
    }

  }

  initReviews()
  $(window).on('scroll', function() {
    initReviews()
  })
  $(window).on('load', function() {
    setTimeout(function() {
      initReviews(true)
    }, 2000)
  })
}

if (document.querySelector('#yotpo-testimonials-custom-tab')) {
  yotpoLoad()
}



/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

/**
 * a11y.pageLinkFocus
 *
 * For use when focus shifts to a container rather than a link
 * eg for In-page links, after scroll, focus shifts to content area so that
 * next `tab` is where user expects if focusing a link, just $link.focus();
 *
 * @param {JQuery} $element - The element to be acted upon
 */

/**
 * a11y.focusHash
 *
 * If there's a hash in the url, focus the appropriate element
 */

/**
 * a11y.bindInPageLinks
 *
 * When an in-page (url w/hash) link is clicked, focus the appropriate element
 */

/**
 * a11y.trapFocus
 *
 * Traps the focus in a particular container
 *
 * @param {object} options - Options to be used
 * @param {jQuery} options.$container - Container to trap focus within
 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
 * @param {string} options.namespace - Namespace used for new focus event handler
 */

/**
 * a11y.removeTrapFocus
 *
 * Removes the trap of focus in a particular container
 *
 * @param {object} options - Options to be used
 * @param {jQuery} options.$container - Container to trap focus within
 * @param {string} options.namespace - Namespace used for new focus event handler
 */
theme.Sections=function Sections(){this.constructors={};this.instances=[];$(document).on('shopify:section:load',this._onSectionLoad.bind(this)).on('shopify:section:unload',this._onSectionUnload.bind(this)).on('shopify:section:select',this._onSelect.bind(this)).on('shopify:section:deselect',this._onDeselect.bind(this)).on('shopify:block:select',this._onBlockSelect.bind(this)).on('shopify:block:deselect',this._onBlockDeselect.bind(this))};theme.Sections.prototype=_.assignIn({},theme.Sections.prototype,{_createInstance:function(container,constructor){var $container=$(container);var id=$container.attr('data-section-id');var type=$container.attr('data-section-type');constructor=constructor||this.constructors[type];if(_.isUndefined(constructor)){return}if(!_.isFunction(constructor)){constructor = constructor[type] || constructor}
var instance=_.assignIn(new constructor(container),{id:id,type:type,container:container});this.instances.push(instance)},_onSectionLoad:function(evt){var container=$('[data-section-id]',evt.target)[0];if(container){this._createInstance(container)}},_onSectionUnload:function(evt){this.instances=_.filter(this.instances,function(instance){var isEventInstance=instance.id===evt.detail.sectionId;if(isEventInstance){if(_.isFunction(instance.onUnload)){instance.onUnload(evt)}}
return!isEventInstance})},_onSelect:function(evt){var instance=_.find(this.instances,function(instance){return instance.id===evt.detail.sectionId});if(!_.isUndefined(instance)&&_.isFunction(instance.onSelect)){instance.onSelect(evt)}},_onDeselect:function(evt){var instance=_.find(this.instances,function(instance){return instance.id===evt.detail.sectionId});if(!_.isUndefined(instance)&&_.isFunction(instance.onDeselect)){instance.onDeselect(evt)}},_onBlockSelect:function(evt){var instance=_.find(this.instances,function(instance){return instance.id===evt.detail.sectionId});if(!_.isUndefined(instance)&&_.isFunction(instance.onBlockSelect)){instance.onBlockSelect(evt)}},_onBlockDeselect:function(evt){var instance=_.find(this.instances,function(instance){return instance.id===evt.detail.sectionId});if(!_.isUndefined(instance)&&_.isFunction(instance.onBlockDeselect)){instance.onBlockDeselect(evt)}},register:function(type,constructor){this.constructors[type]=constructor;$('[data-section-type='+type+']').each(function(index,container){this._createInstance(container,constructor)}.bind(this))}});slate.a11y={pageLinkFocus:function($element){var focusClass='js-focus-hidden';$element.first().attr('tabIndex','-1').focus().addClass(focusClass).one('blur',callback);function callback(){$element.first().removeClass(focusClass).removeAttr('tabindex')}},focusHash:function(){var hash=window.location.hash;if(hash&&document.getElementById(hash.slice(1))){this.pageLinkFocus($(hash))}},bindInPageLinks:function(){$('a[href*=#]').on('click',function(evt){this.pageLinkFocus($(evt.currentTarget.hash))}.bind(this))},trapFocus:function(options){var eventName=options.namespace?'focusin.'+options.namespace:'focusin';if(!options.$elementToFocus){options.$elementToFocus=options.$container}
options.$container.attr('tabindex','-1');options.$elementToFocus.focus();$(document).off('focusin');$(document).on(eventName,function(evt){if(options.$container[0]!==evt.target&&!options.$container.has(evt.target).length){options.$container.focus();options.$elementToFocus.focus()}})},removeTrapFocus:function(options){var eventName=options.namespace?'focusin.'+options.namespace:'focusin';if(options.$container&&options.$container.length){options.$container.removeAttr('tabindex')}
$(document).off(eventName)}};




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Shopify = (function() {
  function getProduct(data) {
    var product = "";
    $.ajax({
      method: "GET",
      url: "/products/"+data+"?view=json",
      async: false,
      complete: function(r) {
        product = JSON.parse(r.responseText);
      }
    });
    return product;
  }

  function formatMoney(money) {
    return "$"+(money / 100).toLocaleString(undefined, {minimumFractionDigits: 2})
  }

  function addItem(id, qty, parent) {
    var promise = new Promise(function(resolve) {
      var params = {
        type: "POST",
        url: "/cart/add.js",
        data: {
          "quantity": qty,
          "id": id,
        },
        dataType: "json",
        success: resolve,
        error: function(XMLHttpRequest, textStatus) {
          theme.Cart.addtocartError(XMLHttpRequest, parent);
        }
      };
      $.ajax(params);
    });
    promise.then(function(r) {
    });
  }

  function massAddItem(items, parent) {
    var data = {
      updates: items
    }
    var cart = theme.Shopify.getCart();
    cart.then(function(r) {
      $.each(data.updates, function(id, qty) {
        if(typeof qty == "number") {
          var quantity = qty;
        }
        $.each(r.items, function(i, line_item) {
          if(line_item.variant_id == id) {
            quantity += line_item.quantity;
            data.updates[id] = quantity;
          }
        });
      });
      var promise = new Promise(function(resolve) {
        var params = {
          type: "POST",
          url: "/cart/update.js",
          data: data,
          dataType: "json",
          success: resolve,
          error: function(XMLHttpRequest, textStatus) {
            theme.OrderForm.addtocartError(XMLHttpRequest, parent);
          }
        };
        $.ajax(params);
      });
  
      promise.then(function(res) {
        if(parent.find('.pb__actions .add-error').length > 0) {
          parent.find('.pb__actions .add-error').remove();
        }
        parent.find('.action-msg').html("<span class='add-success'>Successfully added to cart</span>")
        setTimeout(function(){
          $('.add-success').remove();
        }, 3000);
      });
    }).catch(e => {
      console.log(e);
    });
  }

  function getCart() {
    return new Promise(function(resolve) {
      $.getJSON("/cart.js", function(r) {
        resolve(r);
      });
    });
  }

  function getCartJSON() {
    return new Promise(function(resolve) {
      $.get("/cart?view=json", function(r) {
        resolve(JSON.parse(r));
      });
    });
  }

  function changeCartItemQuantity(row, qty) {
    var promise = new Promise(function(resolve) {
      var params = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity="+qty+"&line="+row,
        dataType: "json",
        success: resolve,
        error: function(XMLHttpRequest, textStatus) {
          theme.Cart.addtocartError(XMLHttpRequest);
        }
      };
      $.ajax(params);
    });
    promise.then(function(r) {
      theme.SideCart.updateSideCartPrices();
      theme.Cart.buildProductList();
      // theme.SideCart.buildSideCart();
      theme.Header.updateCount();
    }).catch(e => {
      console.log(e);
    });
    return promise
  }

  function updateWholeCart(data) {
    var promise = new Promise(function(resolve) {
      var params = {
        type: "POST",
        url: "/cart/update.js",
        data: {
          updates: data
        },
        dataType: "json",
        success: resolve,
        error: function(XMLHttpRequest, textStatus) {
          theme.Cart.addtocartError(XMLHttpRequest);
        }
      };
      $.ajax(params);
    });
    promise.then(function(r) {
    }).catch(e => {
      console.log(e);
    });
  }

  function addItemFromForm(e) {
    e.preventDefault();

    var data = $(e.target).serializeArray(), limit = false;

    if (typeof productTags != 'undefined') {
      productTags.forEach(function(tag) {
        if (tag == 'limit') {
          window.cart.products.forEach(function(item) {
            if (item.product_id == currentProductId) {
              limit = true;
            }
          })
        }
      });
    }
    // data.forEach(function(el) {
    //   if (el.name == 'id') {
    //     window.cart.products.forEach(function(item) {
    //       if (item.variant_id == parseInt(el.value)) {
    //         item.tags.forEach(function(tag) {
    //           if (tag.toLowerCase() == 'limit') {
    //             limit = true;
    //           }
    //         })
    //       }
    //     })
    //   }
    // })

    if (limit) {
      alert("You can't add more of this product");
      return;
    }

    var promise = new Promise(function(resolve) {
      var params = {
        type: "POST",
        url: "/cart/add.js",
        data: $(e.target).serialize(),
        dataType: "json",
        complete: resolve
      };
      $.ajax(params)
    });

    promise.then(function(response) {
      theme.Header.updateCount();
      theme.SideCart.buildSideCart();
      theme.SideCart.openSideCart();
      theme.Cart.buildProductList();
    }).catch(e => {
      console.log(e);
    });
  }

  function getProducts(handles) {
    promises = handles.map(function(handle) {

      return new Promise(function(resolve) {
        $.get("/products/"+handle+"?view=json", function(result) {
          try {
            resolve(JSON.parse(result));
          }
          catch(e) {
            console.error(e);
            resolve;
          }
        });
      });
    });

    return Promise.all(promises);
  }

  function getCollection(handle, page) {
    if(page) {
      return new Promise(function(resolve) {
        $.get("/collections/"+handle+"?view=json&page="+page+"", function(result) {
          resolve(JSON.parse(result));
        });
      });
    } else {
      return new Promise(function(resolve) {
        $.get("/collections/"+handle+"?view=json", function(result) {
          resolve(JSON.parse(result));
        });
      });
    }
  }

  function getCollectionJSON(handle) {
    var collection = "";
    $.ajax({
      method: "GET",
      url: "/collections/"+handle+"?view=json",
      async: false,
      complete: function(r) {
        collection = JSON.parse(r.responseText);
      }
    });
    return collection;
  }

  function getSizedImageUrl(src, size) {
    if(size === null) {
      return src;
    }

    if(src.indexOf("data:image") > -1) {
      return src;
    }

    if (size === 'master') {
      return removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    getCart: getCart,
    getProduct: getProduct,
    getProducts: getProducts,
    getCollection: getCollection,
    getCollectionJSON: getCollectionJSON,
    getSizedImageUrl: getSizedImageUrl,
    addItem: addItem,
    addItemFromForm: addItemFromForm,
    formatMoney: formatMoney,
    removeProtocol: removeProtocol,
    changeCartItemQuantity: changeCartItemQuantity,
    massAddItem: massAddItem,
    getCartJSON: getCartJSON,
    updateWholeCart: updateWholeCart,
  }
})();




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Global = (function() {
  var cache = {
    $body: $("body"),
    $container: $(".page-container"),
    $modal: $(".modal"),
    $owl_carousels: $(".owl-carousel:not(.owl-manual)"),
    $modal_save: $(".modal__saving"),
    $modal_text: $(".modal__saving-text"),

    $technology_match_image: $(".techpic"),

    $automatic_product_carousel: $("[data-carousel-product-list]")
  }

  var selectors = {
    add_to_cart_forms: "form[action='/cart/add']:not(.noAjax)",
    owl_carousels: ".owl-carousel:not(.owl-manual)",
    quickview: ".btn--quickview",
    upsell_variant_select: ".upsell-variants",
  }

  var classes = {
    navigation_toggle: "open-navigation",
    scrolled: "scrolled",
    search_toggle: "open-search",
    filter_toggle: "filters-open"    
  }

  function Global() {
    if (typeof geoip2 !== 'undefined') {
      geoip2.country(onGeoSuccess, onGeoError);
    }
    cache.owl_settings = theme.owl_carousel;

    cache.$container.on('click', closeSearch);
    cache.$modal.on("click", closeAllOpenPopups);

    $(document).on("click", selectors.quickview, showQuickView);

    $(document).on("click", ".footer__badge", function() {
      window.location.href = "/pages/reviews";
    })

    $(document).on("submit", selectors.add_to_cart_forms, theme.Shopify.addItemFromForm);

    if($(window).scrollTop() > 0) {
      cache.$body.addClass(classes.scrolled);
      cache.$body.removeClass('at-top');
    } else {
      cache.$body.removeClass(classes.scrolled);
      cache.$body.addClass('at-top');
    }
    $(window).on("scroll", function(e) {
      if($(this).scrollTop() > 0) {
        cache.$body.addClass(classes.scrolled);
        cache.$body.removeClass('at-top');
      } else {
        cache.$body.removeClass(classes.scrolled);
        cache.$body.addClass('at-top');
      }
    });

    if(cache.$technology_match_image.length > 0) {
      cache.$technology_match_image.on("click", technologyNavigate);
    }

    cache.$automatic_product_carousel.each(buildProductCarousel);

    cache.$owl_carousels.each(initializeOwlCarousel);
    $(document).arrive(selectors.owl_carousels, initializeOwlCarousel);

    $(window).resize(function() {
      if($(window).width() > theme.settings.breakpoint.desktop) {
        theme.Header.closeSearch();
      }
    });
  }

  function onGeoSuccess(res) {

    if (!localStorage.getItem('saved_currency')) {
      var selected_cur = 'USD';
      if (res.continent.code == 'EU') {
        selected_cur = 'EUR';
      }
      if (res.country.iso_code == 'AU') { selected_cur = 'AUD'; }
      if (res.country.iso_code == 'BR') { selected_cur = 'BRL'; }
      if (res.country.iso_code == 'CA') { selected_cur = 'CAD'; }
      if (res.country.iso_code == 'CH') { selected_cur = 'CHF'; }
      if (res.country.iso_code == 'DK') { selected_cur = 'DKK'; }
      if (res.country.iso_code == 'GB' || res.country.iso_code == 'UK') { selected_cur = 'GBP'; }
      if (res.country.iso_code == 'HK') { selected_cur = 'HKD'; }
      if (res.country.iso_code == 'NO') { selected_cur = 'NOK'; }
      if (res.country.iso_code == 'NZ') { selected_cur = 'NZD'; }
      if (res.country.iso_code == 'SE') { selected_cur = 'SEK'; }
      if (res.country.iso_code == 'ZA') { selected_cur = 'ZAR'; }
      if (res.country.iso_code == 'JP') { selected_cur = 'YEN'; }

      if (selected_cur != 'USD'){document.querySelector('.currency-wrapper [data-cur="' + selected_cur + '"]').click()}
    }

    localStorage.setItem('geo', res.country.iso_code)

    var $msg = $(".marquee__item");
    if(theme.marquee.enableGeo) {
      if(res.country.iso_code !== "US") {
        $msg.find('span').text(theme.marquee.internationalMsg);
        $msg.css('display', 'block');
      } else {
        $msg.find('span').text(theme.marquee.usMsg);
        $msg.css('display', 'block');
      }
    } else {
      $msg.css('display', 'block');
    }
  }

  function onGeoError(res) {
    console.log('Geo error', res)
  }

  function buildProductCarousel() {
    var $container = $(this);
    var product_list = $container.attr("data-carousel-product-list").split(",");
  
    if(product_list != "") {
      theme.Shopify.getProducts(product_list).then(function(products) {
        $container.append(theme.Product.createCollectionCarousel(products, false));

        setTimeout(function() {
          lazyLoadInstance.update();
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
        }, 100);
      }).catch(e => {
        console.log(e);
      });
    }
  }

  function showQuickView(e) {
    e.preventDefault();

    var handle = $(this).attr("data-product-handle");

    theme.Shopify.getProduct(handle).then(function(products) {
      theme.Product.createProductQuickview(products[0]);
    }).catch(e => {
      console.log(e);
    });
  }

  function technologyNavigate(e) {
    e.preventDefault();
        
    var half = $(this).height() / 2;
    var width = $(this).width();
    
    var x = e.pageX - $(this).offset().left;
    var y = e.pageY - $(this).offset().top;
        
    if(y > half) {
      if(x > 0 && x < (width / 3)) window.location.href = "/products/no-filter-foundation-stix";
      else if((x > (width / 3)) && (x < (width / 3 * 2))) window.location.href = "/products/no-filter-matte-foundation";
      else window.location.href = "/products/no-filter-concealer";
    }
  }

  function initializeOwlCarousel() {
    if(typeof $(this).attr("data-special") != "undefined") {
      if($(this).attr("data-special") == "marquee") {
        $(this).owlCarousel({
          autoplay: true,
          autoplayTimeout: 7000,
          center: true,
          loop: false,
          rewind: true,
          animateOut: 'slideOutDown',
          mouseDrag: false,
          nav: false,
          dots: false,
          items: 1
        });
      }
    }
    else {
      $(this).owlCarousel({
        autoplayTimeout: 7000,
        navText: cache.owl_settings.default.navText,
        lazyLoad: ($(this).is("[data-lazy]") ? true : cache.owl_settings.default.lazyLoad),
        loop: ($(this).is("[data-loop]") ? true : cache.owl_settings.default.loop),
        margin: ($(this).is("[data-margin]") ? parseInt($(this).attr("data-margin")) : cache.owl_settings.default.margin) ,
        nav: ($(this).is("[data-nav]") ? true : cache.owl_settings.default.nav),
        dots: ($(this).is("[data-dots]") ? true : cache.owl_settings.default.dots),
        autoWidth: ($(this).is("[data-autowidth]") ? true : false),
        center: ($(this).is("[data-center]") ? true : false),
        autoplay: ($(this).is("[data-autoplay]") ? true : false),
        responsive: {
          0: { 
            items: ($(this).is("[data-mobile]") ? $(this).attr("data-mobile") : 1),
          },
          767: { 
            items: ($(this).is("[data-tablet]") ? $(this).attr("data-tablet") : ($(this).is("[data-mobile]") ? $(this).attr("data-mobile") : 1)),
            slideBy: ($(this).is("[data-tablet-slideBy]") ? $(this).attr("data-tablet-slideBy") : 2)
          },
          1025: { 
            items: ($(this).is("[data-desktop]") ? $(this).attr("data-desktop") : 1),
            slideBy: ($(this).is("[data-desktop-slideBy]") ? $(this).attr("data-desktop-slideBy") : 4)
          }
        },
        onInitialized: function(event) {
          var dataset = event.target.dataset;

          if(dataset.startposition !== undefined) {
            setTimeout(function() {
              $(event.currentTarget).trigger("to.owl.carousel", parseInt(dataset.startposition));
            }, 100);
          }
        }
      });
    }
  }

  function openModal() {
    cache.$modal_save.hide();
    cache.$modal.show();
    cache.$modal.animate({
      opacity: "0.5"
    }, 300);
  }

  function closeModal() {
    cache.$modal_save.hide();
    cache.$modal.animate({
      opacity: "0"
    }, 100, function() {
      cache.$modal.hide();
    });
  }

  function closeAllOpenPopups() {
    theme.Navigation.closeNavigation();
    theme.SideCart.closeSideCart();
    closeModal();
    closeSearch();
  }

  function closeSearch() {
    cache.$body.removeClass(classes.search_toggle);
  }

  function openSearch() {
    cache.$body.addClass(classes.search_toggle);
  }

  function toggleFilters() {
    cache.$body.toggleClass(classes.filter_toggle);
  }

  function showLoadingSpinner(string) {
    openModal();
    cache.$modal_save.show();
    cache.$modal_text.html(string);
  }

  return {
    Global: Global,
    openModal: openModal,
    closeModal: closeModal,
    openSearch: openSearch,
    closeSearch: closeSearch,
    closeAllOpenPopups: closeAllOpenPopups,
    toggleFilters: toggleFilters,
    showLoadingSpinner: showLoadingSpinner
  }
})();




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Header = (function() {
  var cache = {
    crisps: null,
    $body: $("body"),
    $side_cart: $("[data-section-type='SideCart']"),
    $side_cart_overlay: $(".sidecart_overlay"),
    $marquee_text: $(".marquee__item"),
    $marquee_parent: $(".marquee__parent")
  }

  var classes = {
    navigation_toggle: "open-navigation",
    slide_open: "open",
    sub_menu_show: "show",
  }

  var selectors = {
    container: "[data-section-id='header']",
    hamburger: ".header__hamburger",
    hamburger_menu: ".hamburger_menu",
    side_cart_btn: ".cart-button",
    continue_shopping: ".cart_content__continue-shopping",
    menu_overlay: ".menu_overlay",
    search_btn: '.search-button',
    header_search_container: '.header__search.hideDesktop',
    header_search_container_404_mobile: '.header__search.hideDesktop.mobile__404',
    search_dropdown: '.header__search-dropdown',
    search_results: '.header__search-results',
    parent_menu_item: '.sub-menu--parent',
    parent_menu_item_link: '.sub-menu--parent-link',
    sub_menu: '.hamburger_menu--sub-menu',
    sub_menu_back: '.sub-menu--back',
    cart_count: '.cart-button__count',
    search_bar_close: '.header__search--close',
  }

  function Header() {
    cache.crisps = theme.CrispAPI.initializeCrisp("search");
    updateCount();

    $(selectors.hamburger).on('click', menuOpen);
    $(selectors.menu_overlay).on('click', menuClose);
    $(document).on('click', selectors.continue_shopping, theme.SideCart.closeSideCart);
    $(selectors.side_cart_btn).on('click', function(e) {
      setTimeout(function() {
        theme.SideCart.buildSideCart();
      }, 50)
      theme.SideCart.openSideCart();
    });
    $(selectors.search_btn).on('click', openSearch);
    $(selectors.parent_menu_item_link).on('click', openSubMenu);
    $(selectors.sub_menu_back).on('click', function(e) {
      e.preventDefault();
      $('.hamburger_menu.sub').removeClass(classes.sub_menu_show);
      $('.hamburger_menu.parent').removeClass('hide');
    });
    $(document).on('keyup', selectors.search_bar_close, function(e) {
      if(e.keyCode == 13) {
        closeSearch();
      }
    });

    if($(".header__search-dropdown").length < 1) {
      $("body").removeClass("open-search");
    }

    if($(window).width() > theme.settings.breakpoint.desktop) {
      $(document).on('keyup', ".header__search.showDesktop #header__search--input", showSearchDropdown)
    }
  }

  function updateCount() {
    theme.Shopify.getCart().then(function(r) {
      var count = r.item_count;
      if(count > 9) {
        count = "9+";
        $(selectors.cart_count).css("right", "-85%");
      } else {
        $(selectors.cart_count).css("right", "-60%");
      }
      $(selectors.cart_count).text(count);

      //marquee text update
      if(theme.marquee.enableGeo) {
        if(theme.marquee.enableShippingMin) {
          geoip2.country((res) => {
            if(res.country.iso_code == "US") {
              if(cache.$marquee_text.hasClass('min_shipping_msg')) {
                if(cache.$marquee_text.length > 0) {
                  var free_shipping_min = cache.$marquee_parent.attr('data-shippingMin');
                  var cart_subtotal = r.total_price;
                  if (cart_subtotal == 0) {
                    cache.$marquee_text.find('span').text("Free US Shipping on orders over "+window.EXCHANGE.ex(free_shipping_min)+"");
                  } else if(cart_subtotal < free_shipping_min) {
                    var amount_from_free = parseInt(free_shipping_min) - r.total_price;
                    cache.$marquee_text.find('span').text("Only "+window.EXCHANGE.ex(amount_from_free)+" away from Free US shipping!")
                  } else if (cart_subtotal > free_shipping_min) {
                    cache.$marquee_text.find('span').text("Congratulations! You've got Free US shipping!");
                  }
                }
              }
            }
          });
        }
      }
    }).catch(e => {
      console.log(e);
    });

  }

  function openSubMenu(e) {
    e.preventDefault();
    e.stopPropagation();
    var parent_handle = $(this).parent().data().linkType;
    var parent_title = parent_handle.replace(/-/g, ' ');;
    var child_to_show;
    $('.sub-menu--title label').text(parent_title);
    $(selectors.sub_menu).each(function() {
      $(this).removeClass(classes.sub_menu_show);
      if ($(this).data().linkType == parent_handle) {
        child_to_show = this;
      }
    });
    $('.hamburger_menu.parent').addClass('hide');
    $('.hamburger_menu.sub').addClass(classes.sub_menu_show);
    $(child_to_show).toggleClass(classes.sub_menu_show);
  }

  //when clicking hamburger icon
  function menuOpen(e) {
    // already open
    closeSearch();

    if($(selectors.hamburger_menu).hasClass(classes.slide_open)) {
      var scrollY = cache.$body.css('top');
      cache.$body.removeClass(classes.navigation_toggle);
      cache.$body.css({ top: "" });
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      $(selectors.hamburger_menu).removeClass(classes.slide_open);
      $(selectors.hamburger_menu).removeClass('hide');
      cache.$body.removeClass('at-top');
    } else {
      // not open
      if(!cache.$body.hasClass('open-sidecart')) {
        cache.$body.css({ top: "-"+window.scrollY+"px" });
      }
      cache.$body.addClass(classes.navigation_toggle);
      if(cache.$body.css('top') !== '0px') {
        cache.$body.removeClass('at-top');
      } else {
        cache.$body.addClass('at-top');
      }
      $(selectors.hamburger_menu).addClass(classes.slide_open);
      $('.hamburger_menu.sub').removeClass(classes.sub_menu_show);
    }
    $(selectors.menu_overlay).toggleClass('open');
    // $(selectors.hamburger_menu).toggleClass(classes.slide_open);

    if(cache.$body.hasClass('scrolled')) {
      cache.$body.removeClass('at-top');
    }
    
    //close side cart if open
    if(cache.$body.hasClass('open-sidecart')) {
      cache.$side_cart.hide();
      cache.$side_cart_overlay.removeClass('open');
      cache.$body.removeClass("open-sidecart");
    }
  }

  function menuClose(e) {
    var scrollY = cache.$body.css('top');
    cache.$body.removeClass(classes.navigation_toggle);
    cache.$body.css({ top: "" });
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    $(selectors.menu_overlay).removeClass('open');
    $(selectors.hamburger_menu).removeClass(classes.slide_open);
    $(selectors.hamburger_menu).removeClass('hide');
    cache.$body.removeClass('at-top');
  }

  function closeAllModal() {
    cache.$side_cart.hide();
    cache.$side_cart_overlay.removeClass('open');
    var scrollY = cache.$body.css('top');
    cache.$body.removeClass(classes.navigation_toggle);
    cache.$body.removeClass("open-sidecart");
    cache.$body.css({ top: "" });
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    $(selectors.menu_overlay).removeClass('open');
    cache.$side_cart_overlay.removeClass(classes.slide_open);
    $(selectors.hamburger_menu).removeClass(classes.slide_open);
    cache.$side_cart.removeClass(classes.slide_open);
    cache.$body.removeClass('at-top');
    cache.$side_cart.animate({
      right: "-100%"
    }, 300, function() {
    });
  }

  function openSearch(e) {

    if(cache.$body.hasClass('open-sidecart') || cache.$body.hasClass('open-navigation')) {
      closeAllModal();
    }

    var string = "<div class='header__search hideDesktop'> \
      <label class='visually-hidden'>Search bar</label> \
      <form class='header__search--form' action='/search'> \
        <input type='hidden' name='type' value='product'> \
        <div class='header__search--container'> \
          <label for='header__search--input' class='visually-hidden'>Search</label> \
          <input type='text' name='q' id='header__search--input' placeholder=\"Enter your search terms\" /> \
          <button class='header__search--submit'>Search</button> \
        </div> \
      </form> \
      <button class='header__search--close visually-hidden'>Close Search Bar</button> \
    </div>";

    if($(selectors.header_search_container).length > 0) {
      closeSearch();
    } else {
      if($(window).width() < theme.settings.breakpoint.desktop) {
        $(selectors.container).append(string);
        $(".header__search.hideDesktop #header__search--input").focus();
        $(".header__search.hideDesktop #header__search--input").keyup(showSearchDropdown);
      }
    }

  }

  function showSearchDropdown(e) {
    var search_value = $(this).val().toLowerCase();
    if(search_value.length >= 2)
    {
      var product_list = theme.CrispAPI.getSearchResults(cache.crisps, search_value, true);
      product_list.then(function(products) {
        if(products.length > 0) {
          if($(selectors.search_dropdown).length == 0) {
            var $dropdown = $("<div/>").html("<div class='header__search-dropdown'></div>").contents();
            var $results = $("<ul/>").html("<ul class='header__search-results'></ul>").contents();
          }
          else {
            var $dropdown = $(selectors.search_dropdown);
            var $results = $(selectors.search_results);
          }

          $results.empty();
          $.each(products, function(index, product) {
            if (product.tags.join('|').toLowerCase().indexOf('search_hidden') == -1) {
              $results.append(createSearchPreview(product));
            }
          });

          
          if($results.children().length == 0) {
            $(selectors.search_dropdown).remove();
          }
          else {
            $dropdown.append($results);
            $('.header__search-dropdown--cta').remove();
            var $viewMore = "<div class='header__search-dropdown--cta'>\
                              <a href='/search?q="+search_value+"'>View All Results</a>\
                            </div>";
            $dropdown.append($viewMore);
            if($(window).width() > theme.settings.breakpoint.desktop) {
              $('.header__search.showDesktop').append($dropdown);
            } else {
              $(selectors.header_search_container).append($dropdown);
            }
          }
        }
      }).catch(e => {
        console.log(e);
      });
    }
    else {
      $(selectors.search_dropdown).remove();
    }
  }

  function createSearchPreview(product) {
    return " \
      <li>\
        <a class='search-preview__container' href='"+product.url+"'> \
          <div class='search-preview'> \
            <div class='search-preview__image'> \
              <picture>\
                <source media='(min-width: "+theme.settings.breakpoint.tablet+"px)' srcset='"+theme.Shopify.getSizedImageUrl(product.images[0].img, "400x")+"' /> \
                <source media='(min-width: 0px)' srcset='"+theme.Shopify.getSizedImageUrl(product.images[0].img, "200x")+"' /> \
                <img src='"+theme.Shopify.getSizedImageUrl(product.images[0].img, "200x")+"' alt=''> \
              </picture>\
            </div><div class='search-preview__content'> \
              <label class='search-preview__content--title'>"+product.title+"</label> \
              <label class='search-preview__content--type'>"+product.type+"</label> \
            </div> \
          </div> \
        </a>\
      </li>";
  }

  function closeSearch(e) {
    $('.header__search.hideDesktop:not(.mobile__404)').remove();
  }

  return {
    Header: Header,
    menuClose: menuClose,
    closeSearch: closeSearch,
    updateCount: updateCount
  }
})();




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.SideCart = (function() {
  var cache = {
    $body: $("body"),
    $side_cart: $("[data-section-type='SideCart']"),
    $close: $(".side-cart__header--close"),
    $side_cart_items: $(".side-cart__items"),
    $side_cart_info: $(".side-cart__info"),
    $side_cart_total: $(".cart_totals"),
    $side_cart_overlay: $(".sidecart_overlay"),
    $side_cart_container: $(".side-cart__container"),
    $side_cart_upsell: $(".side-cart__header--upsell"),
    $side_cart_upsell_carousel: $(".upsell-container"),
  }

  var selectors = {
    $decrease_qty: '.item-qty--down',
    $increase_qty: '.item-qty--up',
    $cart_subtotal: '.cart_subtotal',
    $side_cart_item_remove: '.item-remove',
    $side_cart_close: '.side-cart__header--close',
    $side_cart_qty_input: '.item-qty--input',
    menu_overlay: ".menu_overlay",
    hamburger_menu: ".hamburger_menu",
  }

  function getCache() {
    return cache;
  }

  function SideCart() {
    cache.$close.on("click", function() { closeSideCart() });
    cache.$side_cart_overlay.on("click", function() { closeSideCart() });
    $(document).on('click', selectors.$increase_qty, qtyIncrease);
    $(document).on('click', selectors.$decrease_qty, qtyDecrease);
    $(document).on('click', selectors.$side_cart_item_remove, removeItemFromSideCart);
    $(document).on('keyup', selectors.$side_cart_qty_input, updateQty);
  }

  function updateCart() {
    theme.Shopify.getCartJSON().then(function(r) {
      if(r.item_count < 1) {
        cache.$side_cart_upsell.empty()
        cache.$side_cart.removeClass('have_upsell');
        cache.$side_cart_items.html("<div class='cart_empty'>Your cart is empty!</div>");
        cache.$side_cart_container.css("overflow", "hidden");
        $('.cart_totals').remove();
      } else {
        cache.$side_cart_upsell.empty()
        var upsell_product_list = getUpsellList(r);

        var upsell_in_cart = r.products.filter(function(product) {
          return product.handle == theme.settings.general_upsell_product.handle
        });
        if(upsell_product_list) {          var general_upsell_check = r.item_count > 0 && upsell_product_list.length == 0 && upsell_in_cart.length == 0 && theme.settings.general_upsell_product.show;
          if (general_upsell_check) {
            cache.$side_cart.addClass('have_upsell');
            var general_upsell_product_list = [theme.settings.general_upsell_product.handle];
            var general_upsell_block = theme.Product.buildProductUpsell(general_upsell_product_list, true)
            cache.$side_cart_upsell.empty().show();
            cache.$side_cart_upsell.html(general_upsell_block);
          } else {
            if(upsell_product_list.length > 0) {
              cache.$side_cart.addClass('have_upsell');
              var upsell_block = theme.Product.buildProductUpsell(upsell_product_list, true);
              cache.$side_cart_upsell.empty().show();
              cache.$side_cart_upsell.append(upsell_block);
            } else {
              cache.$side_cart.removeClass('have_upsell');
            }
          }
        }
      }
    }).catch(e => {
      console.log(e);
    });
  }

  function buildSideCart() {
    cache.$side_cart_items.empty();
    cache.$side_cart_total.empty();
    theme.Shopify.getCartJSON().then(function(r) {
      var string = "";
      if(r.item_count < 1) {
        cache.$side_cart_upsell.empty()
        cache.$side_cart.removeClass('have_upsell');
        string += "<div class='cart_empty'>Your cart is empty!</div>";
        cache.$side_cart_container.css("overflow", "hidden");
      } else {
        cache.$side_cart_upsell.empty()
        var upsell_product_list = getUpsellList(r);

        $.each(r.products, function(i, item) {
          var index = i + 1;
          string += buildProductList(item, index, true);
        });

        cache.$side_cart_total.attr('data-total', window.theme.Shopify.formatMoney(r.total_price))

        var info = "<div class='cart_subtotal js-cart_subtotal'>\
                      <span>Subtotal</span>\
                      <span class='money' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" +r.total_price + "'>"+window.EXCHANGE.ex(r.total_price)+"</span>\
                    </div>";
        if($(".cart_subtotal").length < 1) {
          cache.$side_cart_total.append(info);
        }
      }

      cache.$side_cart_items.html(string);

      var upsell_in_cart = r.products.filter(function(product) {
         return product.handle == theme.settings.general_upsell_product.handle
        });
      var general_upsell_check = r.item_count > 0 && upsell_product_list.length == 0 && upsell_in_cart.length == 0 && theme.settings.general_upsell_product.show;
      if (general_upsell_check) {
        cache.$side_cart.addClass('have_upsell');
        var general_upsell_product_list = [theme.settings.general_upsell_product.handle];
        var general_upsell_block = theme.Product.buildProductUpsell(general_upsell_product_list, true)
        
        cache.$side_cart_upsell.empty().show();
        cache.$side_cart_upsell.html(general_upsell_block);
      } else {
        if(upsell_product_list.length > 0) {
          cache.$side_cart.addClass('have_upsell');
          var upsell_block = theme.Product.buildProductUpsell(upsell_product_list, true);
          
          cache.$side_cart_upsell.empty().show();
          cache.$side_cart_upsell.append(upsell_block);
        } else {
          cache.$side_cart.removeClass('have_upsell');
        }
      }
      theme.Product.handleLimitSpecialProduct()
    }).catch(e => {
      console.log(e);
    });
  }

  function getUpsellList(cart) {
    var cartArray = [];
    $.each(cart.products, function(i, cartItem) {
      cartArray.push(cartItem.handle);
    });
    var upsell_product_list = [];
    $.each(cart.products, function(i, item) {
      $.each(item.tags, function(i, tag) {
        if(tag.indexOf('upsell:') > -1) {
          var handle = tag.replace('upsell:', '').split('#')[0];
          if(cartArray.indexOf(handle) < 0) {
            var in_upsell_list = false;
            $.each(upsell_product_list, function(i, upsellProduct) {
              if(upsellProduct == handle) {
                in_upsell_list = true;
                return false;
              }
            });
            if(!in_upsell_list) {
              upsell_product_list.push(handle);
            }
          }
        }
      })
    });
    return upsell_product_list;
  }

  function buildProductList(data, i, returnHTML) {
    var limit = false;
    data.tags.forEach(function(tag) {
      if (tag.toLowerCase() == 'limit') {
        limit = true
      }
    })
    if(data.product_title == data.variant_title) {
      var variant_name = "";
    } else {
      var variant_name = data.variant_title;
    }
    var item = "<li class='side-cart__item' data-row='"+i+"'>\
                  <a href='"+data.url+"'>\
                    <div class='item-image'>\
                      <picture>\
                        <source media='(min-width: "+theme.settings.breakpoint.tablet+"px)' srcset='"+data.image+"' /> \
                        <source media='(min-width: 0px)' srcset='"+data.image+"' /> \
                        <img src='"+data.image+"' alt=''> \
                      </picture>\
                    </div>\
                  </a>\
                  <div class='side-cart__item--info'>\
                    <span class='item-title'>"+data.product_title+"</span>\
                    <span class='item-variant'>"+variant_name+"</span>\
                    <div class='item-price'>";
    if(data.variant_compare_at_price !== null) {
      item += "<span class='compare-at-price' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + data.variant_compare_at_price + "'>"+window.EXCHANGE.ex(data.variant_compare_at_price)+"</span>\
              <span class='sale-price' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + data.final_price + "'>"+window.EXCHANGE.ex(data.final_price)+"</span>";
    } else {
      item += "<span class='sale-price no-sale' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + data.final_price + "'>"+window.EXCHANGE.ex(data.final_price)+"</span>";
    }
    item += "</div>\
              <div class='item-qty' " + (limit ? ' style="display:none"' : '') + ">\
                <button class='text-link item-qty--down down' field='quantity'>\
                  <img src='//cdn.shopify.com/s/files/1/1338/0835/files/icon-minus.svg?8342380176482341839' alt='Decrease Quantity' />\
                </button>\
                <input type='text' name='quantity' min='1' class='quantity item-qty--input' value='"+data.quantity+"' />\
                <button class='text-link up item-qty--up' field='quantity'>\
                  <img src='//cdn.shopify.com/s/files/1/1338/0835/files/icon-plus.svg?8342380176482341839' alt='Increase Quantity' />\
                </button>\
              </div>\
              <div class='item-remove'>\
                <img src='https://cdn.shopify.com/s/files/1/0266/4339/8691/files/icons8-delete-50.png?2844' />\
              </div>\
            </div>\
          </li>";
    if(!returnHTML) {
      cache.$side_cart_items.prepend(item);
    } else {
      return item;
    }
  }

  function updateSideCartPrices() {
    theme.Shopify.getCart().then(function(r) {
      window.cart = r;
      $(".cart_subtotal").parent().attr('data-total', window.theme.Shopify.formatMoney(r.total_price))
      $(".cart_subtotal span.money").attr('data-base', r.total_price);
      $(".cart_subtotal span.money").text(window.EXCHANGE.ex(r.total_price));
    }).catch(e => {
      console.log(e);
    });
  }

  function openSideCart() {
    theme.Header.closeSearch();
    if(cache.$body.hasClass('open-sidecart')) {
      return false;
    }
    
    cache.$side_cart.show();
    cache.$side_cart_overlay.addClass('open');
    if(!cache.$body.hasClass('open-navigation')) {
      cache.$body.css({ top: "-"+window.scrollY+"px" });
    }
    if(cache.$body.css('top') !== '0px') {
      cache.$body.removeClass('at-top');
    } else {
      cache.$body.addClass('at-top');
    }
    cache.$side_cart_upsell_carousel.trigger("to.owl.carousel", 1);
    cache.$body.addClass("open-sidecart");
    cache.$side_cart.animate({
    right: "0%"
    }, 300);
    $(selectors.$side_cart_close).focus();

    if(cache.$body.hasClass('scrolled')) {
      cache.$body.removeClass('at-top');
    }

    const $cartCheckoutButtons = $('#haim-cart-checkout-buttons');
    
    //close menu if open
    if(cache.$body.hasClass('open-navigation')) {
      cache.$body.removeClass('open-navigation');
      $(selectors.menu_overlay).removeClass('open');
      $(selectors.hamburger_menu).removeClass('open');
      $('.hamburger_menu.sub').removeClass('show');
      $('.hamburger_menu.parent').removeClass('hide');
    }
    else if(!$cartCheckoutButtons.hasClass('hvck-side-cart-buttons')){
      const loadingClass = 'is-loading';
      
      $cartCheckoutButtons
          .addClass(loadingClass);
      
      $.ajax({
              type: 'GET',
              url: '/cart?view=ajax_side_cart',
              cache: false,
              success: function (data) {
                  var response = $(data);
      
                  $cartCheckoutButtons
                      .removeClass(loadingClass)
                      .html(response);

                  $cartCheckoutButtons
                      .addClass('hvck-side-cart-buttons');
              },
              error: function (xhr, text) {
                  // alert($.parseJSON(xhr.responseText).description);
                  //halo.showWarning($.parseJSON(xhr.responseText).description);
                console.log($.parseJSON(xhr.responseText).description);
              },
              complete: function () {
                  console.log('buttons loaded');
              }
          });
      
    }
  }

  function closeSideCart() {
    cache.$side_cart.hide();
    cache.$side_cart_overlay.removeClass('open');
    var scrollY = cache.$body.css('top');
    cache.$body.removeClass("open-sidecart");
    cache.$body.css({ top: "" });
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    cache.$body.removeClass('at-top');
    cache.$side_cart.animate({
    right: "-100%"
    }, 300, function() {
    });
  }

  function updateQty(e) {
    e.preventDefault();
    var key = e.keyCode || e.charCode;
    if( key == 8 || key == 46 )
        return false;
    var val = $(this).val();
    var row = $(this).parents(".side-cart__item").data('row');
    if(val < 1) {
      $(".side-cart__item[data-row='"+row+"']").remove();
    }
    theme.Shopify.changeCartItemQuantity(row, val);
  }

  function qtyDecrease(e) {
    e.preventDefault();
    var row = $(this).parents(".side-cart__item").data('row');
    var $input = $(this).parents('.item-qty').find('.item-qty--input');
    var current_qty = parseInt($input.val());

    if(current_qty <= 1) {
      $input.val(1);
    }
    else {
      var new_qty = current_qty - 1;
      $input.val(new_qty);
      theme.Shopify.changeCartItemQuantity(row, new_qty);
    }
  }

  function qtyIncrease(e) {
    e.preventDefault();
    var row = $(this).parents(".side-cart__item").data('row');
    var $input = $(this).parents('.item-qty').find('.item-qty--input');
    var new_qty = parseInt($input.val()) + 1;
    $input.val(new_qty);
    theme.Shopify.changeCartItemQuantity(row, new_qty);
  }

  function removeItemFromSideCart(e) {
    e.preventDefault();
    var row = parseInt($(this).parents('.side-cart__item').attr('data-row'));
    theme.Shopify.changeCartItemQuantity(row, 0).then(function() {
      theme.Product.handleLimitSpecialProduct();
      updateCart();
    }).catch(e => {
      console.log(e);
    });
    $(".side-cart__item[data-row='"+row+"']").remove();
    $(".side-cart__item").each(function(i) {
      $(this).attr('data-row', i + 1);
    })
  }

  return {
    SideCart: SideCart,
    getCache: getCache,
    openSideCart: openSideCart,
    closeSideCart: closeSideCart,
    buildProductList: buildProductList,
    buildSideCart: buildSideCart,
    updateSideCartPrices: updateSideCartPrices,
    getUpsellList: getUpsellList
  }
})();





/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.CrispAPI = (function() {
  var cache = {
    collection_template: "json",
    search_template: "json",

    products_per_page: 24,
    products_per_preview: 5
  }

  function initializeCrisp(type, handle, default_order) {
    if(type == "collection") {
      if(!handle) {
        console.error("CRISP: Invalid Collection Handle");
      }
      else {
        return Crisp.Collection({
          handle: handle,
          template: cache.collection_template,
          order: default_order
        });
      }
    }
    else if(type == "search") {
      return Crisp.Search({
        query: '',
        template: cache.search_template,
        exact: false,
        types: ['product']
      });
    }
    // searchCollection only works when there's no query
    else if(type == "searchCollection") {
      return Crisp.SearchableCollection({
        handle: 'all',
        collectionTemplate: cache.collection_template,
        searchTemplate: cache.search_template
      });
    }

    return false;
  }

  function getSearchResults(crisps, value, preview) {
    //if(typeof window.didyoumean[search_val] != "undefined")
    //  search_val = window.didyoumean[search_val];
    if(preview) {
      crisps.setQuery(decodeURIComponent(value));
      return crisps.preview({
        number: cache.products_per_preview
      });
    }
    else {
      return crisps.getNext({
        number: cache.products_per_page,
        offset: 10
      })
    }
  }


  function initializeCrispFilters(filters) {
    return Crisp.Filter({
      global: [
        function(payload) {
          return (payload.tags.indexOf('hidden-collection') === -1 && payload.tags.indexOf('hidden-true') === -1);
        },
      ],
      filters: filters
    });
  }


  function getProducts(crisp) {
    return crisp.getNext({
      number: cache.products_per_page
    })
  }

  return {
    initializeCrisp: initializeCrisp,
    getProducts: getProducts,
    initializeCrispFilters: initializeCrispFilters,
    getSearchResults: getSearchResults
  }
})();




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Product = (function() {
  var cache = {
    productData: null,
    selectedVariantId: "",
    $quantity_down: $('.product-actions__quantity--down'),
    $quantity_up: $('.product-actions__quantity--up'),
    $quantity_box: $('.product-actions__quantity--input'),
    $product_recommendation: $('.product-recommendations'),
    $product_upsell: $('.product-upsell'),
    $product_thumbnails: $('.product-thumbnails'),
  }

  var selectors = {
    $main_image_carousel: '.product-images__gallery',
    $thumbnail_carousel: '.product-thumbnails__gallery',
    $image_thumb: '.product-thumb',
    $carousel_centered: ".owl-item.center",
    $carousel_uncentered: ".owl-item:not(.center)",
    $price: '.price',
    $price_compare: '.compare-at-price',
    $sku: '.product-sku',
    $add_input: ".product-actions__addtocart input[name='id']",
    $variant_options: '.variant_options',
    $variant_swatches: '.swatch-element input[type="radio"]',
    $inventory_msg: '.variant-inventory__message',
  }

  function Product() {
    cache.$quantity_down.on("click", decreaseQuantity);
    cache.$quantity_up.on("click", increaseQuantity);
    $(document).on('click', selectors.$image_thumb, handleThumbnail);
    $(document).on('change', selectors.$variant_swatches, onVariantChange);
    $(document).on('click', '.product-images__gallery .owl-next', handleOwlNav)
    $(document).on('click', '.product-images__gallery .owl-prev', handleOwlNav)
    getProductData(fillProductData);

    initProductGallery();

    // buildMainCarousel();
    // buildThumbnail();

    theme.Shopify.getCartJSON().then(function(cart) {
      window.cart = cart;
    })

    handleLimitSpecialProduct()
  
    buildProductRecommendation();

    if (cache.productData.upsell.length > 0 && cache.productData.handle != cache.productData.upsell[0].handle) {
      buildProductUpsell(cache.productData.upsell, false);
    };


    $(selectors.$main_image_carousel).on('dragged.owl.carousel', function() {
      var position = $(selectors.$carousel_centered).find('.product-image').data('position');
      $(selectors.$thumbnail_carousel).trigger('to.owl.carousel', position);
    });

    yotpoLoad()
  }

  function handleOwlNav() {
    var position = $(this).parents(selectors.$main_image_carousel).find('.owl-item.active .product-image').data('position');
    $(selectors.$thumbnail_carousel).trigger('to.owl.carousel', position);
  }

  function buildProductUpsell(upsellData, returnHtml) {
    var string = "";
    if(upsellData && upsellData.length > 0) {
      string += " \
        <div class='upsell-container'>\
          <label class='upsell-title'>Bundle with this</label>";
      
      if(upsellData.length > 1) {
        string += " \
          <div class='owl-carousel owl-theme' "+(!returnHtml ? "data-center data-autoWidth" : "")+" data-nav data-desktop='1' data-mobile='1' data-autoWidth data-center>";
      }
      $.each(upsellData, function(i, item_handle) {
        var product = theme.Shopify.getProduct(item_handle);
        if(product.available) {
          string += " \
              <div class='upsell-container--items'> \
                <form action='/cart/add' method='post' class='upsell-details__container'> \
                  <input type='hidden' name='quantity' value='1' /> \
                  <a href='"+product.url+"'> \
                    <div class='upsell-details__image'> \
                      <picture class='visible'>\
                        <source media='(min-width: "+theme.settings.breakpoint.tablet+"px)' srcset='"+(returnHtml ? theme.Shopify.getSizedImageUrl(product.images[0].img, "320x320") : theme.Shopify.getSizedImageUrl(product.images[0].img, "200x200"))+"' /> \
                        <source media='(min-width: 0px)' srcset='"+(returnHtml ? theme.Shopify.getSizedImageUrl(product.images[0].img, "160x160") : theme.Shopify.getSizedImageUrl(product.images[0].img, "160x160"))+"' /> \
                        <img src='"+(returnHtml ? theme.Shopify.getSizedImageUrl(product.images[0].img, "160x160") : theme.Shopify.getSizedImageUrl(product.images[0].img, "160x160"))+"' alt='"+product.handle+"'> \
                      </picture>\
                    </div> \
                  </a> \
                  <div class='upsell-details__info'> \
                    <span class='upsell-details__info--title'>"+product.title+"</span> \
                    <label class='upsell-details__info--price'>";
                  if(product.compare_at_price_max > product.price ) {
                    string += " \
                      <span class='visually-hidden'>Compare At Price</span>\
                      <span class='compare-at-price' data-show data-money data-basec='" + window.EXCHANGE.current_currency + "' data-base='" + product.compare_at_price_max + "'>"+window.EXCHANGE.ex(product.compare_at_price_max)+"</span>";
                  }
            string += " \
                      <span class='visually-hidden'>Sale Price</span>\
                      <span class='sale-price "+(product.compare_at_price_max == "" ? 'no-sale' : 'sale-price')+"' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + product.price + "'>"+window.EXCHANGE.ex(product.price)+"</span> \
                    </label>";

            string += "<div class='upsell-product__info--rating'> \
                        <div class='yotpo bottomLine' data-product-id='"+product.id+"'></div> \
                      </div>"
            string += "<div class='upsell-actions'>";
            if(product.variants.length > 1) {
              string += " \
                    <select class='upsell-variants' name='id'>";
              $.each(product.variants, function(i, v) {
                if(v.available) {
                  string += " \
                        <option value='"+v.id+"' >"+v.title+"</option>"
                }
              });
              string += " \
                    </select>";
            }
            else {
              string += "<input type='hidden' name='id' value='"+product.variants[0].id+"' />";
            }
  
            string += " \
                      <input type='submit' class='btn btn--secondary' value='Add to Cart'> \
                    </div>\
                  </div> \
                </form> \
              </div>";
        }
      });
      string += " \
          </div>";

      if(upsellData.length > 1) {
        string += " \
        </div>";
        }
    }
    if(!returnHtml) {
      // var $string = $('<div/>').html(string).contents();
      cache.$product_upsell.append(string);
      cache.$product_upsell.show();
    } else {
      return string;
    }
  }

  function buildProductRecommendation() {
    var product_id = Number(cache.productData.id);
    fetch(window.Shopify.routes.root + `recommendations/products?product_id=${product_id}&limit=10&section_id=recommendation-products&intent=related`)
    .then(response => response.text())
    .then((text) => {
        const recommendationProduct = document.querySelector('.js-product-recommendation');
        recommendationProduct.innerHTML = text;

        const collectionSwiperEl = recommendationProduct.querySelector('swiper-container.collection-swiper');
        const swiperParams = {
          navigation: true,
          slidesPerView: 1.5,
          spaceBetween: 10,
          breakpoints: {
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 24,
            },
          },
          injectStyles: [
            `
            :root {
              --swiper-navigation-size: 30px;
              --swiper-theme-color: #000;
            }
            `,
            `@media screen and (max-width: 768px) {
              .swiper-button-next, .swiper-button-prev {
                display: none;
              }
            }
            `,
          ],
        };

        Object.assign(collectionSwiperEl, swiperParams);
        collectionSwiperEl.initialize();
    });
  }

  function createCollectionCarousel(products, remove_loop) {
    var string = "<div class='owl-carousel owl-theme owl-carousel--collection' data-nav "+(remove_loop ? "" : "data-loop")+" data-desktop='5' data-tablet='3' data-mobile='1.5' >";
    $.each(products, function(index, product) {
      if(product) {
        string += createCarouselProductCard(product, true);
      }
    });
    string += "</div>";

    return string;
  }

  function createCarouselProductCard(product, return_string) {
    var product_img = "";
    if(typeof product.images[0] == 'object') {
      product_img = product.images[0].img;
    } else {
      product_img = product.images[0];
    }
    var string = "<div class='carousel__item' data-handle='"+product.handle+"'>\
                    <a href='"+product.url+"'>\
                      <div class='carousel-product__image'> \
                        <img id='"+product.id+"-desktop-image' class='hidemobile lazy' data-src='"+theme.Shopify.getSizedImageUrl(product_img, "341x")+"' alt='"+product.title+"' /> \
                        <img id='"+product.id+"-mobile-image' class='showmobile lazy' data-src='"+theme.Shopify.getSizedImageUrl(product_img, "200x")+"' alt='"+product.title+"' /> \
                      </div>\
                    </a>\
                    <div class='carousel-product__content'>\
                      <div class='carousel-product__info'>\
                        <label id='"+product.id+"-title' class='carousel-product__info--title'>"+product.title+"</label> \
                        <div class='carousel-product__info--price'>";
    if(product.compare_at_price > 0) {
      string += "<label class='compare-at-price' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + product.compare_at_price + "'>"+window.EXCHANGE.ex(product.compare_at_price)+"</label>\
                  <label class='sale-price' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + product.price + "'>"+window.EXCHANGE.ex(product.price)+"</label>";
    } else {
      string += "<label class='sale-price no-sale' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + product.price + "'>"+window.EXCHANGE.ex(product.price)+"</label>";
    }
    string += "</div>\
              <div class='carousel-product__info--rating'> \
                <div class='yotpo bottomLine' data-product-id='"+product.id+"'></div> \
              </div> \
            </div>\
            <div class='carousel-product__action' data-handle=''"+product.handle+"'>\
              <form class='carousel-product__action--form' method='post' action='/cart/add'> \
                <input type='hidden' name='id' value='"+product.variants[0].id+"' /> \
                <input type='hidden' name='quantity' value='1' /> \
              </form>\
            </div>\
          </div>\
        </div>";
        // Add to cart btn: "<input "+(product.available ? '' : 'disabled="disbled"')+" class='btn' value='"+(product.available ? 'VIEW PRODUCT' : 'OUT OF STOCK')+"' />";
    if(return_string) {
      return string;
    }

    var $string = $('<div/>').html(string).contents();
    return $string;
  }

  function handleThumbnail() {
    var position = $(this).attr('data-position');
    var $largeCarousel = $(this).parents('.product-content__left').find('.product-images__gallery');
    $largeCarousel.trigger('to.owl.carousel', position);
  }

  function initProductGallery() {
    const swiperElS = document.querySelectorAll('.gallery-swiper');

    swiperElS.forEach(function (swiperEl) {
      const params = {
        slidesPerView: 1,
        navigation: true,
        injectStyles: [
          `
          :root {
            --swiper-navigation-size: 50px;
            --swiper-theme-color: #000;
            --swiper-navigation-top-offset: 0;
          }
          `,
          `.swiper-button-next, .swiper-button-prev {
              height: 100%;
          }
          `
        ],
      };
  
      Object.assign(swiperEl, params);
  
      swiperEl.initialize();
    });
  }

  function getProductData(callback) {
    var productData = theme.Shopify.getProduct(theme.settings.product_handle);
    cache.productData = productData;
    callback(cache.productData);
  }

  function onVariantChange() {
    $('.swatch-element').removeClass('checked');
    $(this).closest('.swatch-element').addClass('checked');

    var option = $(this).closest('.swatch').find('.swatch-header').text().toLowerCase();
    var optionValue = $(this).val();
    if(option == 'color') {
      // move slider as selected variant
      // const gallerySwiper = document.querySelector('.js-gallery-main-swiper');
      resetGallerySlider(optionValue);

      // const selectedColorSwiper = gallerySwiper.querySelector(`swiper-slide[alt="${optionValue}"]`);

      // if (selectedColorSwiper) {
      //   const swiperIndex = selectedColorSwiper.getAttribute("data-swiper-slide-index");
      //   gallerySwiper.swiper.slideTo(Number(swiperIndex));
      // }
    }

    var selectedId = "";
    var selectedPrice = "";
    var selectedComparePrice = "";
    var selectedSku = "";
    var selectedInventory = "";
    $.each(cache.productData.variants, function(i, variant) {
      if(variant.title == optionValue) {
        selectedId = variant.id;
        selectedPrice = variant.price;
        selectedComparePrice = variant.compare_at_price;
        selectedSku = variant.sku;
        selectedInventory = parseInt(variant.inventory_quantity);
      }
    });
    if(selectedInventory > 0 && selectedInventory <= 20) {
      $(selectors.$inventory_msg).html("<span>HURRY! Only <span class='v_inventory'>"+selectedInventory+"</span> Left in Stock</span>");
    } else {
      $(selectors.$inventory_msg).html("");
    }
    $(selectors.$add_input).val(selectedId);
    $(selectors.$price).attr('data-base', selectedPrice);
    $(selectors.$price).text(window.EXCHANGE.ex(selectedPrice));
    $(selectors.$price_compare).attr('data-base', selectedComparePrice);
    $(selectors.$price_compare).text(window.EXCHANGE.ex(selectedComparePrice));
    $(selectors.$sku).text("SKU: " + selectedSku);

    $('.product-price').html(
      '<span class="compare-at-price" data-show data-money data-basec="USD" data-base="' + selectedComparePrice + '">'+window.EXCHANGE.ex(selectedComparePrice)+'</span> \
      <span class="price" data-show data-money data-basec="USD" data-base="' + selectedPrice + '">'+window.EXCHANGE.ex(selectedPrice)+'</span>'
    )

    if (selectedComparePrice <= selectedPrice) {
      if (!$(selectors.$price).hasClass('single')) {
        $('.product-price').html(
          '<span class="price single" data-show data-money data-basec="USD" data-base="' + selectedPrice + '">'+window.EXCHANGE.ex(selectedPrice)+'</span>')
      }
    }

    if($(this).closest('.swatch-element').hasClass('soldout')) {
      $('form.product-actions').addClass('soldout');
      $('.product-actions__submit').prop('disabled', true);
    } else {
      $('form.product-actions').removeClass('soldout');
      $('.product-actions__submit').prop('disabled', false);
    }
  }

  function resetGallerySlider(selectedVariant) {
    const sliders = document.querySelectorAll('.js-gallery-color');
    sliders.forEach(function (slider) {
      slider.classList.add('disable-slider');
      if (slider.dataset.color == selectedVariant) {
        slider.classList.remove('disable-slider');
      }
    });
    // const gallerySwiper = document.querySelector('.js-gallery-main-swiper');
    // const galleryItems = gallerySwiper.querySelectorAll('swiper-slide');
    // const galleryThumb = document.querySelector('.js-gallery-thumb-swiper');
    // const galleryThumbItems = galleryThumb.querySelectorAll('swiper-slide');
    
    // galleryItems.forEach(function (item) {
    //   item.classList.remove('hidden');
    //   item.classList.remove('swiper-slide-visible');

    //   if (item.getAttribute('alt') == selectedVariant) {
    //     item.classList.add('swiper-slide-visible');
    //   } else {
    //     item.classList.add('hidden');
    //   }
    // });

    // galleryThumbItems.forEach(function (item) {
    //   // item.classList.remove('hidden');
    //   // item.classList.remove('swiper-slide-visible');

    //   if (item.getAttribute('alt') == selectedVariant) {
    //     item.style.display = 'block';
    //   } else {
    //     item.style.display = 'none';
    //   }
    // });

    // // galleryThumb.swiper.destroy();
    // // galleryThumb.initialize();
    // galleryThumb.swiper.updateSlides();
    // galleryThumb.swiper.update();
    // gallerySwiper.swiper.update();
    // gallerySwiper.swiper.updateSlides();
  }

  function fillProductData(data) {
    var selectedVariant = $(".product-actions__addtocart input[name='id']").val();
    var $option = $(".variant_options[data-variantid='"+selectedVariant+"']");
    var $element = $(".swatch-element[data-variantid='"+selectedVariant+"']");
    $option.addClass('selected');
    if($element.hasClass('soldout')) {
      $('form.product-actions').addClass('soldout');
      $('.product-actions__submit').prop('disabled', true);
    }
    $.each(data.variants, function(i, variant) {
      if(variant.id == parseInt(selectedVariant)) {
        if(variant.inventory_quantity <= 20) {
          $(selectors.$inventory_msg).html("<span>HURRY! Only <span class='v_inventory'>"+variant.inventory_quantity+"</span> Left in Stock</span>");
        }
      }
    })
    $(selectors.$price).attr('data-base', data.price);
    $(selectors.$price).text(window.EXCHANGE.ex(data.price));
    $(selectors.$price_compare).attr('data-base', data.compare_at_price_max);
    $(selectors.$price_compare).text(window.EXCHANGE.ex(data.compare_at_price_max));
    $(selectors.$sku).text("SKU: " + data.sku);
  }

  function decreaseQuantity(e) {
    e.preventDefault();
    var current_quantity = parseInt(cache.$quantity_box.val());

    if(current_quantity <= 1) {
      cache.$quantity_box.val(1);
    }
    else {
      cache.$quantity_box.val(current_quantity - 1);
    }
  }

  function increaseQuantity(e) {
    e.preventDefault();
    cache.$quantity_box.val(parseInt(cache.$quantity_box.val()) + 1);    
  }

  function handleLimitSpecialProduct() {
    if (theme.settings.template == 'product' && theme.settings.product_handle == theme.settings.special_product_handle) {
      var exists = false;
      theme.Shopify.getCart().then(function(cart) {
        cart.items.filter(function(item) {
          if (item.handle == theme.settings.special_product_handle) {
            $('input.product-actions__submit').prop('disabled', true);
            $('p.special-product-message').html('You already have one in your cart. If you want different options, you will need to remove it from your cart first.');
            exists = true;
          } 
        });
        if (exists == false) {
          $('input.product-actions__submit').prop('disabled', false);
          $('p.special-product-message').html('');
        }
      }).catch(e => {
        console.log(e);
      });
    }
  }

  return {
    Product: Product,
    createCollectionCarousel: createCollectionCarousel,
    buildProductUpsell: buildProductUpsell,
    handleLimitSpecialProduct: handleLimitSpecialProduct
    }
})();




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Collection = (function() {
  var cache = {
    products_count: 0,
    product_list: [],
    filters_logic: [],
    crisp: null,
    crisp_filter: null,
    filter_data: null,
    default_order: "best-selling",
    collection_order: "",
    $container: $('.collection__container'),
    $filters_container: $('.collection-filters__container'),
    $filters_dropdown: $('.collection-filters__dropdown'),
    $sorting_container: $('.sort-container'),
    $floating_container: $(".collection__floating")
  }

  var selectors = {
    filter_group_parent: '.collection-filter__group',
    filter_group: '.filter-group__options',
    filter: '.filter-group__options--item',
    filter_group_title: '.filter-group__title',
    product_block: '.productblock',
    filter_checkbox: '.item__checkbox',
    filter_count: '.filter-group__title--number',
    product_end: '.product__listing--end',
    product_empty: '.product__listing--empty',
    sort_dropdown: '#product-sorting',
  }

  function getCache() {
    return cache;
  }

  function Collection() {
    cache.filter_data = collection_filters;
    cache.collection_order = theme.settings.collection_order == "manual" ? "best-selling" : theme.settings.collection_order;
    cache.crisp = theme.CrispAPI.initializeCrisp("collection", theme.settings.collection_handle, cache.collection_order);


    $(selectors.sort_dropdown).val(cache.collection_order);
       
      
    loadFilters(cache.filter_data);
    cache.crisp_filter = theme.CrispAPI.initializeCrispFilters(cache.filters_logic);
    setFiltersByHistory();

    $(document).on('click', selectors.filter_group_title, showFilterItems);
    $(document).on('click', selectors.filter_checkbox, updateFilter);
    $(document).on('change', selectors.sort_dropdown, handleSort);

    $(document).on('click', function(e) {
      var filter = $('.collection__filters');
      if(!filter.is(e.target) && filter.has(e.target).length === 0) {
        cache.$filters_dropdown.removeClass('open');
        cache.$filters_container.removeClass('open');
      }
    });

    yotpoLoad()
    
    cache.$filters_dropdown.on("click", showFilters);
    
    window.onpopstate = setFiltersByHistory;

    var infiniteScroll = function() {
      if($(window).scrollTop() + $(window).height() > $(document).height() - 1200) {
        $(window).unbind("scroll", infiniteScroll);
        loadProducts();

        setTimeout(function() {
          $(window).bind("scroll", infiniteScroll);
        }, 500);
      }
    }

    setTimeout(function() {
      $(window).bind("scroll", infiniteScroll);
    }, 2000);
  }

  function handleSort(e) {
    cache.crisp.setOrder($(this).val());

    resetProducts();
    loadProducts();
  }

  function loadFilters(filter_data) {
    var filter_list = filter_data[0].filters;

    $.each(filter_data, function(index, data) {
      if(data.handles.indexOf(theme.settings.collection_handle) > -1) {
        filter_list = data.filters;
        return false;
      }
    });
        
    $.each(filter_list, function(group, filters) {
      //if(group == 'Color' || group == 'Material') {
      //  filters = filters.sort();
      //} else if (group == 'Width / Diameter' || group == 'Item Insertable Length Range' || group == 'Unit Price') {
      //  var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
      //  filters = filters.sort(collator.compare);
      //}

      var $group = theme.Filter.createFilterGroup(group);
      var $filter_container = $group.find(selectors.filter_group);

      $.each(filters, function(index, filter) {
        var $filter = theme.Filter.createFilterItems(group, filter);

        $filter_container.append($filter);
        cache.$filters_container.append($group);
      });

      var children = [];
      $.each(filters, function(i, filter) {
        var filter_group = group.toLowerCase().replace(/ /g,"_");
        var filter_tag = "#." + filter_group + ":" + filter;
        children.push({
          name: filter,
          filter: function(payload) {
            return (payload.tags.indexOf(filter_tag) !== -1);
          }
        })
      });
      cache.filters_logic.push({ title: group, children: children });
    });
  }

  function loadProducts() {
    var product_list = theme.CrispAPI.getProducts(cache.crisp);

    product_list.then(function(response) {
      if((theme.settings.collection_handle == 'new-items' || theme.settings.collection_handle == 'best-selling') && (cache.products_count > 248)) {
        showEndOfCollectionResults();
      }
      else if(response.length == 0) {
        if($(selectors.product_block).length > 0) {
          showEndOfCollectionResults();
        } else {
          showEmptyCollectionResults();
        }
      } 
      else {
        $.each(response, function(index, product) {
          cache.products_count += 1;
          cache.$container.append(createProductBlock(product));
        });

        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      }

      lazyLoadInstance.update();
    }).catch(e => {
      console.log(e);
    });
  }

  function showEmptyCollectionResults() {
    if($(selectors.product_empty).length == 0) {
      cache.$container.html(" \
      <div class='product__listing--end'> \
        <label>No products to show</label> \
      </div>");
    }
  }

  function showEndOfCollectionResults() {
    if($(selectors.product_end).length == 0) {
      cache.$container.append(" \
        <div class='product__listing--end'> \
          <label>No more products to show</label> \
        </div>");
    }
  }

  function createProductBlock(product) {
    var string = "";

    string = "<div class='productblock' product-id='"+product.id+"'> \
                <div class='productblock__imagecontainer'>\
                  <a href='"+product.url+"'>\
                    <div class='imagecontainer__image--swapper'>";

                    $.each(product.images, function(index, image) {
                      string += " \
                        <picture aria-hidden='true'> \
                          <source media='(min-width: "+theme.settings.breakpoint.tablet+"px)' srcset='"+theme.Shopify.getSizedImageUrl(image.img, "400x")+"' /> \
                          <source media='(min-width: 0px)' srcset='"+theme.Shopify.getSizedImageUrl(image.img, "200x")+"' /> \
                          <img src='"+theme.Shopify.getSizedImageUrl(image.img, "1x")+"' alt='"+image.alt+"'> \
                        </picture>";
                  
                      if(index == 1 || $(window).width() < theme.settings.breakpoint.desktop) {
                        return false;
                      }
                    }); 

                string += " \
                    </div> \
                  </a> \
                </div> \
                <div class='productblock__info' data-handle='"+product.handle+"'>\
                  <label class='info__title'>"+product.title+"</label> \
                  <div class='info__price'><div class='info__price-item'>";
    if(product.available) {
      if(product.compare_at_price_max > product.price) {
        string += "<span class='compare-at-price' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + product.compare_at_price_max + "'>"+window.EXCHANGE.ex(product.compare_at_price_max)+"</span>";
      }
      string += "<span class='sale-price' data-show data-money data-basec='" + window.EXCHANGE.current_currency +"' data-base='" + product.price + "'>"+window.EXCHANGE.ex(product.price)+"</span></div>";
    } 
    else {
      string += "<div class='info__price'>SOLD OUT</div>";
    }
                  
   string += " \
              <div class='yotpo bottomLine' data-product-id='"+product.id+"'></div> \
            </div>\
          </div>";

    var $string = $('<div/>').html(string).contents();
    return $string;
  }

  function setFiltersByHistory() {
    $(selectors.filter_checkbox).prop("checked", false);
    var filters = [];
    if (history.state != null) {
      if('filters' in history.state && history.state.filters !== "") {
        filters = history.state.filters.split(',');
        $.each(filters, function(i, filter) {
          $(""+selectors.filter_checkbox+"[value='"+filter+"']").prop("checked", true);
        })
      }
    }

    cache.crisp_filter.setQuery(filters.join(","));
    cache.crisp.setFilter(cache.crisp_filter.fn());

    updateFilterCount(true);
    resetProducts();
    loadProducts();
  }

  function updateFilter(e) {
    var filter = $(this).val();
    var group = $(this).attr('data-group');
    var filter_name = group + "_" + filter;
    if($(""+selectors.filter_checkbox+"[id='"+filter_name+"']:checked").length > 0) {
      cache.crisp_filter.select(filter);
    } else {
      cache.crisp_filter.deselect(filter);
    }
    
    history.pushState({ "filters": cache.crisp_filter.getQuery() }, '', "?q="+cache.crisp_filter.getQuery());
    resetProducts();
    loadProducts();
    updateFilterCount();
  }

  function updateFilterCount() {
    var total_count = 0;
    $(selectors.filter_group_parent).each(function(){
      var count = $(this).find(""+selectors.filter_checkbox+":checked").length;
      $(this).find(selectors.filter_count).html((count > 0 ? "("+count+")" : ""));
      total_count = total_count + count;
    }); 

    $('.collection-filters__dropdown--number').html(" (" + total_count + ")");
  }

  function showFilterItems(e) {
    e.stopPropagation();
    if($(this).parent(selectors.filter_group_parent).hasClass('open')) {
      $(this).parent(selectors.filter_group_parent).removeClass('open');
    } else {
      $('.collection-filter__group').removeClass('open');
      $(this).parent(selectors.filter_group_parent).addClass('open');
    }
  }

  function showFilters(e) {
    e.stopPropagation();
    cache.$filters_dropdown.toggleClass('open');
    cache.$filters_container.toggleClass('open');
  }

  function resetProducts() {
    cache.products_count = 0;
    cache.$container.children().remove();
    cache.crisp.clearOffset();
  }

  return {
    Collection: Collection,
    getCache: getCache,
    createProductBlock: createProductBlock,
    loadFilters: loadFilters,
  }
})();




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Filter = (function() {

  function createFilterGroup(group) {
    return (
      $('<div/>').html("\
        <div class='collection-filter__group' data-group='"+group+"'>\
          <div class='filter-group__title'> \
            <span class='visuallyhidden'>Toggle Filters: </span>"+group+" \
            <span class='visuallyhidden'>Current Selected "+group+" filters:</span> \
            <span class='filter-group__title--number'></span> \
          </div> \
          <div class='filter-group__options'></div> \
        </div>").contents()
    )
  }

  function createFilterItems(group, filter) {
    if(group == 'color') {
      return (
        $("<div/>").html(" \
        <div class='filter-group__options--item' filter='"+group+"_"+filter+"'> \
          <p class='color-selector'><span data-color='"+filter+"'></span></p>\
          <input data-group='"+group+"' id='"+group+"_"+filter+"' class='item__checkbox visuallyhidden' type='checkbox' value='"+filter+"' /> \
          <label data-group='"+group+"' data-filter='"+filter+"' for='"+group+"_"+filter+"' class='item__label'><span class='visuallyhidden'>Refine by "+group+": </span>"+filter+"</label> \
        </div>").contents()
      )
    } else {
      return (
        $("<div/>").html(" \
        <div class='filter-group__options--item' filter='"+group+"_"+filter+"'> \
          <input data-group='"+group+"' id='"+group+"_"+filter+"' class='item__checkbox visuallyhidden' type='checkbox' value='"+filter+"' /> \
          <label data-group='"+group+"' data-filter='"+filter+"' for='"+group+"_"+filter+"' class='item__label'><span class='visuallyhidden'>Refine by "+group+": </span>"+filter+"</label> \
        </div>").contents()
      )
    }
  }
  
  return {
    createFilterGroup: createFilterGroup,
    createFilterItems: createFilterItems
  }
})();




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Search = (function() {
  var cache = {
    search_filter_data: null,
    search_filter_logic: [],
    search_crisp_filter: null,
    search_value: decodeURIComponent(theme.settings.parameters.get("q")).toLowerCase(),
    $search_filter_container: $('.search-filters__container'),
    $search_filter_dropdown: $('.search-filters__dropdown'),
    $search_container: $('.search-results__container'),
    $floating_search_container: $(".search__floating"),
    crisps: null
  }

  var selectors = {
    $title: '.title.filters',
    filter_group_parent: '.collection-filter__group',
    filter_group: '.filter-group__options',
    filter: '.filter-group__options--item',
    filter_group_title: '.filter-group__title',
    filter_checkbox: '.item__checkbox',
    filter_count: '.filter-group__title--number',
    product_end: '.product__listing--end',
    product_empty: '.product__listing--empty',
    product_block: '.productblock',
  }

  function Search() {
    cache.search_filter_data = collection_filters;
    // $(selectors.$title).append(": " + encodeURI(cache.search_value));
    $(selectors.$title).append(": " + decodeURI(cache.search_value));
    loadFilters(cache.search_filter_data);
    cache.crisps = theme.CrispAPI.initializeCrisp("search");
    cache.crisps.setQuery(cache.search_value);
    // getSearchProducts();
    cache.search_crisp_filter = theme.CrispAPI.initializeCrispFilters(cache.search_filter_logic);
  
    setFiltersByHistory();

    cache.$search_filter_dropdown.on("click", showFilters);
    $(document).on('click', selectors.filter_group_title, showFilterItems);
    $(document).on('click', selectors.filter_checkbox, updateFilter);

    $(document).on('click', function(e) {
      var filter = $('.search__filters');
      if(!filter.is(e.target) && filter.has(e.target).length === 0) {
        cache.$search_filter_dropdown.removeClass('open');
        cache.$search_filter_container.removeClass('open');
      }
    });

    window.onpopstate = setFiltersByHistory;
    yotpoLoad()

    var infiniteScroll = function() {
      if($(window).scrollTop() + $(window).height() > $(document).height() - 1200) {
        $(window).unbind("scroll", infiniteScroll);
        getSearchProducts();
        setTimeout(function() {
          $(window).bind("scroll", infiniteScroll);
        }, 500);
      }
    }

    setTimeout(function() {
      $(window).bind("scroll", infiniteScroll);
    }, 2000);
  }

  function loadFilters(data) {
    console.log('data = ', data);
    var filter_data = "";
    var found = false;
    $.each(data, function(i, col) {
      if(col.handles.indexOf(theme.settings.collection_handle) > -1) {
        filter_data = col.filters;
        found = true;
        return false;
      }
    });

    console.log('filter_data = ', filter_data);
    if(!found) {
      $.each(data, function(i, col) {
        if(col.handles.indexOf('default') > -1) {
          filter_data = col.filters;
          return false;
        }
      })
    }
    $.each(filter_data, function(group, filters) {
      if(group == 'Color' || group == 'Material') {
        filters = filters.sort();
      } else if (group == 'Width / Diameter' || group == 'Item Insertable Length Range' || group == 'Unit Price') {
        var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
        filters = filters.sort(collator.compare);
      }

      var $group = theme.Filter.createFilterGroup(group);

      var $filter_container = $group.find(selectors.filter_group);

      $.each(filters, function(index, filter) {
        var $filter = theme.Filter.createFilterItems(group, filter);

        $filter_container.append($filter);
        cache.$search_filter_container.append($group);
      });

      var children = [];
      $.each(filters, function(i, filter) {
        var filter_group = group.toLowerCase().replace(/ /g,"_");
        var filter_tag = "#." + filter_group + ":" + filter;
        children.push({
          name: filter,
          filter: function(payload) {
            return (payload.tags.indexOf(filter_tag) !== -1)
          }
        })
      });
      cache.search_filter_logic.push({ title: group, children: children });
    });
  }

  function getSearchProducts() {
    // cache.crisps.setQuery(cache.search_value);
    var product_list = theme.CrispAPI.getSearchResults(cache.crisps, cache.search_value);
    product_list.then(function(products) {
      if(products.length == 0) {
        if($(selectors.product_block).length > 0) {
          showEndOfSearchResults();
        }
        else {
          showEmptySearchResults();
        }
      } else {
        $.each(products, function(index, product) {
          if (product.tags.join('|').toLowerCase().indexOf('search_hidden') == -1) {
            cache.$search_container.append(theme.Collection.createProductBlock(product));  
          }  
        });

        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      }
      lazyLoadInstance.update();
    }).catch(e => {
      console.log(e);
    });
  }

  function showFilterItems(e) {
    e.stopPropagation();
    if($(this).parent(selectors.filter_group_parent).hasClass('open')) {
      $(this).parent(selectors.filter_group_parent).removeClass('open');
    } else {
      $('.collection-filter__group').removeClass('open');
      $(this).parent(selectors.filter_group_parent).addClass('open');
    }
  }

  function setFiltersByHistory() {
    $(selectors.filter_checkbox).prop("checked", false);
    var filters = [];
    if (history.state != null) {
      if('filters' in history.state && history.state.filters !== "") {
        filters = history.state.filters.split(',');
        $.each(filters, function(i, filter) {
          $(""+selectors.filter_checkbox+"[value='"+filter+"']").prop("checked", true);
        })
      }
    }

    cache.search_crisp_filter.setQuery(filters.join(","));
    cache.crisps.setFilter(cache.search_crisp_filter.fn());
    updateFilterCount(true);
    resetProducts();
    getSearchProducts();
  }

  function updateFilter(e) {
    var filter = $(this).val();
    var group = $(this).attr('data-group');
    var filter_name = group + "_" + filter;
    if($(""+selectors.filter_checkbox+"[id='"+filter_name+"']:checked").length > 0) {
      cache.search_crisp_filter.select(filter);
    } else {
      cache.search_crisp_filter.deselect(filter);
    }
    
    history.pushState({ "filters": cache.search_crisp_filter.getQuery() }, '', "?q="+cache.search_crisp_filter.getQuery());
    resetProducts();
    getSearchProducts();
    updateFilterCount();
  }

  function updateFilterCount() {
    var total_count = 0;
    $(selectors.filter_group_parent).each(function(){
      var count = $(this).find(""+selectors.filter_checkbox+":checked").length;
      $(this).find(selectors.filter_count).html((count > 0 ? "("+count+")" : ""));
      total_count = total_count + count;
    }); 

    $('.search-filters__dropdown--number').html(" (" + total_count + ")");
  }

  function showFilters(e) {
    e.stopPropagation();
    if(cache.$search_filter_dropdown.hasClass('open')) {
      cache.$search_filter_dropdown.removeClass('open');
    } else {
      cache.$search_filter_dropdown.addClass('open');
    }

    if(cache.$search_filter_container.hasClass('open')) {
      cache.$search_filter_container.removeClass('open');
    } else {
      cache.$search_filter_container.addClass('open');
    }
  }

  function showEmptySearchResults() {
    if($(selectors.product_empty).length < 1) {
      cache.$search_container.html(" \
        <div class='product__listing--empty'> \
          <label>No results for this search. Please try again.</label> \
        </div>");
    }
  }

  function showEndOfSearchResults() {
    if($(selectors.product_end).length < 1) {
      cache.$search_container.append(" \
        <div class='product__listing--end'> \
          <label>No more products to show</label> \
        </div>");
    }
  }

  function resetProducts() {
    cache.$search_container.children().remove();
    cache.crisps.clearOffset();
  }
  return {
    Search: Search,
  }
})();




/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Cart = (function() {
  var cache = {
    $subtotal: $(".cart-total__subtotal--value"),
    $container: $(".cart-table"),
    $upsell_container: $(".cart-upsell")
  }

  var selectors = {
    product_row: ".cart-table__body",
    product_remove: ".cart-table__remove",
    product_quantity: ".cart-table__product-quantity--input",
    product_increment: ".cart-table__product-quantity--increment",
    product_decrement: ".cart-table__product-quantity--decrement",
    product_price: ".cart-table__subtotal"
  }

  function Cart() {
    buildProductList();

    $(document).on("click", selectors.product_remove, handleRemoveProductClick);
    $(document).on("change", selectors.product_quantity, handleProductQuantityChange);
    $(document).on("click", selectors.product_increment, handleIncrementProductClick);
    $(document).on("click", selectors.product_decrement, handleDecrementProductClick);
  }

  function handleProductQuantityChange() {
    var row = $(this).attr("data-row");
    var quantity = parseInt($(this).val()) >= 0 ? parseInt($(this).val()) : 0;

    theme.Shopify.changeCartItemQuantity(row, quantity).then(function(response) {
      buildProductList();
    }).catch(e => {
      console.log(e);
    });
  }

  function handleIncrementProductClick() {
    var $target = $(this).prev();
    var row = $target.attr("data-row");
    var quantity = parseInt($target.val()) + 1;

    theme.Shopify.changeCartItemQuantity(row, quantity).then(function(response) {
      buildProductList();
    }).catch(e => {
      console.log(e);
    });
  }

  function handleDecrementProductClick() {
    var $target = $(this).next();
    var row = $target.attr("data-row");
    var quantity = ((parseInt($target.val()) - 1) >= 0 ? (parseInt($target.val()) - 1) : 0);

    theme.Shopify.changeCartItemQuantity(row, quantity).then(function(response) {
      buildProductList();
    }).catch(e => {
      console.log(e);
    });
  }

  function handleRemoveProductClick() {
    var row = $(this).attr("data-row");

    theme.Shopify.changeCartItemQuantity(row, 0).then(function(response) {
      buildProductList();
    }).catch(e => {
      console.log(e);
    });
  }

  function buildProductList() {
    theme.Shopify.getCartJSON().then(function(cart) {
      window.cart = cart;
      var items = "";
      var product_handles = cart.products.map(function(product) {return product.handle})

      theme.Header.updateCount();

      var upsell_product_list = theme.SideCart.getUpsellList(cart);
      var upsell_block = theme.Product.buildProductUpsell(upsell_product_list, true);
      if (upsell_product_list.length > 0 && !product_handles.includes(upsell_product_list[0].handle)) {
        setTimeout(function() {
          cache.$upsell_container.empty().show();
          cache.$upsell_container.append(upsell_block);
        }, 10);
      } else if (theme.settings.general_upsell_product.show && !product_handles.includes(theme.settings.general_upsell_product.handle) && cart.products.length > 0) {
        var general_upsell_product_list = [theme.settings.general_upsell_product.handle];
        var general_upsell_block = theme.Product.buildProductUpsell(general_upsell_product_list, true);
        
        setTimeout(function() {
          cache.$upsell_container.empty().show();
          cache.$upsell_container.html(general_upsell_block);
        }, 10);
      } else {
        cache.$upsell_container.empty()
      }
      
      if(cart.products.length == 0) {
        items += " \
          <tr class='cart-table__header cart-table__row'> \
            <th class='cart-table__col cart-table__col--empty'>Your cart is currently empty</th> \
          </tr>";
      }
      else {
        items += " \
          <tr class='cart-table__header cart-table__row'> \
            <th class='cart-table__col cart-table__col--1' scope='col'>PRODUCTS</th><th class='cart-table__col cart-table__col--2' scope='col'>PRICE</th><th class='cart-table__col cart-table__col--3' scope='col'>QTY</th><th class='cart-table__col cart-table__col--4' scope='col'>TOTAL</th><th class='cart-table__col cart-table__col--5' scope='col'><span class='visually-hidden'>Remove Action</span></th> \
          </tr>";

        $.each(cart.products, function(index, product) {
          var limit = false;
          product.tags.forEach(function(tag) {
            if (tag.toLowerCase() == 'limit') {
              limit = true
            }
          })

          if (limit) {
            quantities = product.quantity

          } else {
            quantities = "<div class='cart-table__product-quantity'><button data-row='"+(index+1)+"' class='cart-table__product-quantity--decrement' field='quantity'> \
                    <img src='https://cdn.shopify.com/s/files/1/1338/0835/files/icon-minus.svg?8342380176482341839' alt='Decrement Quantity' /> \
                  </button> \
                  <input data-row='"+(index+1)+"' min='1' type='text' name='quantity' class='cart-table__product-quantity--input' value='"+product.quantity+"' /> \
                  <button data-row='"+(index+1)+"' class='cart-table__product-quantity--increment' field='quantity'> \
                    <img src='https://cdn.shopify.com/s/files/1/1338/0835/files/icon-plus.svg?8342380176482341839' alt='Increment Quantity' /> \
                  </button></div>"
          }

          items += " \
            <tr class='cart-table__body cart-table__row "+((product.variant_title !== product.product_title) ? "cart-table__row--has-variant" : "")+"'> \
              <td class='cart-table__col cart-table__col--1'> \
                <div class='cart-table__image'> \
                  <a href='"+product.url+"'> \
                    <picture>\
                      <source media='(min-width: "+product.image+"' /> \
                      <source media='(min-width: 0px)' srcset='"+product.image+"' /> \
                      <img src='"+product.image+"' alt=''> \
                    </picture>\
                  </a> \
                </div><div class='cart-table__product-details'> \
                  <label class='cart-table__product-details--title'>"+product.product_title+"</label>";
          if(product.variant_title !== product.product_title) {
            items += "<label class='cart-table__product-details--variant'>"+product.variant_title+"</label>";
          }
          items += "</div> \
              </td><td class='cart-table__col cart-table__col--2'> \
                <label class='cart-table__mobile-label'>Price</label> \
                <label class='cart-table__price'> \
                  "+(product.original_price != product.original_price?"<span class='visually-hidden'>Original Price</span><span class='price--sale' data-show data-money data-basec='" + window.EXCHANGE.current_currency + "' data-base='" + product.final_price + "'>"+window.EXCHANGE.ex(product.final_price)+"</span>":"")+" \
                  <span class='visually-hidden'>Sale Price</span><span data-show data-money data-base='" + product.original_price + "' data-basec='" + window.EXCHANGE.current_currency + "'>"+window.EXCHANGE.ex(product.original_price)+"</span> \
                </label> \
              </td><td class='cart-table__col cart-table__col--3'> \
                <label class='cart-table__mobile-label'>Qty</label> \
              " + quantities + "</td><td class='cart-table__col cart-table__col--4'> \
                <label class='cart-table__mobile-label'>Total</label> \
                <label class='cart-table__subtotal'> \
                  "+(product.original_subtotal != product.subtotal?"<span class='visually-hidden'>Original Product Subtotal</span><span class='price--sale' data-show data-money data-basec='" + window.EXCHANGE.current_currency + "' data-base='" + product.original_subtotal + "'>"+window.EXCHANGE.ex(product.original_subtotal)+"</span>":"")+" \
                  <span class='visually-hidden'>Product Subtotal</span><span  data-show data-money data-basec='" + window.EXCHANGE.current_currency + "' data-base='" + product.subtotal + "'>"+window.EXCHANGE.ex(product.subtotal)+"</span> \
                </label> \
              </td><td class='cart-table__col cart-table__col--5'> \
                <button class='cart-table__remove' data-row='"+(index+1)+"'> \
                  <img src='https://cdn.shopify.com/s/files/1/1338/0835/files/icon-close.svg?11699190567998258922' alt='Remove "+product.title+" from cart' /> \
                </button> \
              </td> \
            </tr>";
        });
      }

      cache.$container.html(items);
      cache.$subtotal.text(window.EXCHANGE.ex(cart.total_price));
      cache.$subtotal.parent().attr('data-total', window.theme.Shopify.formatMoney(cart.total_price));

    }).catch(e => {
      console.log(e);
    });
  }

  return {
    Cart: Cart,
    buildProductList: buildProductList
  }
})();



/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Login = (function() {

  var selectors = {
    login_container: '.login__container--login',
    register_container: '.login__container--register',
    reset_container: '.login__container--reset',
    login_error: '.login__form-error--login',
    register_error: '.login__form-error--register',
    back: '.form__login--back',
    show_reset: '.form__info--show-reset',
    show_login: '.form__info--show-login',
  }

  function Login() {
    checkErrors()
    $(selectors.show_reset).on('click', showResetPassword)
    $(selectors.show_login).on('click', showResetPassword)
    $(selectors.back).on('click', showLogin)
  }

  function checkErrors() {
    if (window.location.href.indexOf("#recover") > -1) {
      $(selectors.login_container).toggleClass('hide');
      $(selectors.register_container).toggleClass('hide');
      $(selectors.reset_container).toggleClass('hide');
    }

    if (window.location.href.indexOf("return_url") > -1) {
      $(selectors.login_error).toggleClass('hide');
    }

    if (location.href.indexOf("register") > -1) {
      $(selectors.register_error).toggleClass('hide');
    }
  }

  function showResetPassword(e) {
    e.preventDefault();
    $(selectors.login_container).toggleClass('hide');
    $(selectors.register_container).toggleClass('hide');
    $(selectors.reset_container).toggleClass('hide');
    $(selectors.back).toggleClass('hide');
  }

  function showLogin() {
    $(selectors.back).toggleClass('hide');
    $(selectors.login_container).removeClass('hide');
    $(selectors.register_container).removeClass('hide');
    $(selectors.reset_container).addClass('hide');
  }
  
  return {
    Login: Login,
  }
})();


/**
 *
 *
 *
 *
 */
window.theme = window.theme || {};
theme.Addresses = (function() {
  
  var selectors = {
    edit_address: '.address-edit-toggle',
    add_address: '.address-new-toggle',
    edit_form_container: '.edit-address-form',
    add_address_form: '#AddressNewForm',
    edit_address_form: '#EditAddress_'
  }

  function Addresses() {
    $(selectors.add_address).on('click', toggleNewAddressForm)
    $(selectors.edit_address).on('click', toggleEditAddressForm)
    if($('.myaccount__address').length < 1) {
      toggleNewAddressForm();
    }
  }

  function toggleNewAddressForm() {
    if (!$(selectors.edit_form_container).siblings().hasClass('hide')) {
      $(selectors.edit_form_container).addClass('hide');
    }
    $(selectors.add_address_form).toggleClass('hide');
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  function toggleEditAddressForm() {
    var form_id = this.dataset.formId;

      new Shopify.CountryProvinceSelector('AddressCountry_'+form_id, 'AddressProvince_'+form_id, {
        hideElement: 'AddressProvinceContainer_'+form_id
      });

      if (!$(selectors.add_address_form).hasClass('hide')) {
        $(selectors.add_address_form).addClass('hide')
      }

      if (!$(selectors.edit_address_form+form_id).hasClass('hide')) {
        $(selectors.edit_address_form+form_id).addClass('hide');
        return;
      }

      $(selectors.edit_form_container).addClass('hide');
      $(selectors.edit_address_form+form_id).toggleClass('hide');
  }
  
  return {
    Addresses: Addresses,
  }
})();



/**
 *
 *
 *
 *
 */
$(document).ready(function() {
  var sections = new theme.Sections();
  
  sections.register("Global", theme.Global);
  sections.register("Header", theme.Header);
  sections.register("SideCart", theme.SideCart);
  sections.register("Collection", theme.Collection);
  sections.register("Search", theme.Search);
  sections.register("Product", theme.Product);
  sections.register("Cart", theme.Cart);
  sections.register("Login", theme.Login);
  sections.register("Addresses", theme.Addresses);

  // swiper config

  // const swiperEl = document.querySelector('swiper-container');
  // const swiperParams = {
  //   navigation: true,
  //   slidesPerView: 1.2,
  //   spaceBetween: 10,
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 3,
  //     },
  //     1024: {
  //       slidesPerView: 5,
  //       spaceBetween: 24,
  //     },
  //   },
  //   injectStyles: [
  //     `
  //     :root {
  //       --swiper-navigation-size: 30px;
  //       --swiper-theme-color: #000;
  //       --swiper-navigation-sides-offset: 0;
  //     }
  //     .swiper-wrapper {
  //       padding: 0 30px;
  //     }
  //     `,
  //     `.swiper-wrapper {
  //       padding: 0 30px;
  //     }`
  //   ],
  // };

  // Object.assign(swiperEl, swiperParams);
  // swiperEl.initialize();
});

$(theme.init);

